import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    formControl: {
      width: '100%',
    },
    name: {
      marginBottom: theme.spacing(1),
    },
    description: {
      marginBottom: theme.spacing(1),
    },
    characterCount: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(0.5),
    },
    characterCountError: {
      color: theme.palette.error.main,
    },
  });

export default styles;
